export const UI_R8_ICONIC_FLAG = "uiR8Iconic" as const;
export const UI_R8_ICONIC_ENV = "VITE_UI_R8_ICONIC" as const;

export interface UiR8IconicFlagSources {
  explicit?: boolean;
  search?: string;
  environment?: string;
}

const ENABLED_VALUES = new Set(["1", "true", "on", "yes", "enabled"]);
const DISABLED_VALUES = new Set(["0", "false", "off", "no", "disabled"]);

function parseFlagValue(value: string | null | undefined): boolean | undefined {
  if (value == null) return undefined;

  const normalized = value.trim().toLowerCase();
  if (ENABLED_VALUES.has(normalized)) return true;
  if (DISABLED_VALUES.has(normalized)) return false;
  return undefined;
}

/**
 * Resolves the R8 feature flag fail-closed.
 *
 * Precedence is explicit override > URL query > build environment > disabled.
 * A query value is intentionally authoritative, so `?uiR8Iconic=0` is an
 * immediate local rollback even when the build environment enables R8.
 */
export function resolveUiR8IconicFlag(sources: UiR8IconicFlagSources = {}): boolean {
  if (sources.explicit !== undefined) return sources.explicit;

  const query = new URLSearchParams(sources.search ?? "");
  if (query.has(UI_R8_ICONIC_FLAG)) {
    return parseFlagValue(query.get(UI_R8_ICONIC_FLAG)) ?? false;
  }

  return parseFlagValue(sources.environment) ?? false;
}

export function isUiR8IconicEnabled(explicit?: boolean): boolean {
  return resolveUiR8IconicFlag({
    explicit,
    search: typeof window === "undefined" ? "" : window.location.search,
    environment: import.meta.env.VITE_UI_R8_ICONIC,
  });
}
